import {configureStore} from '@reduxjs/toolkit'
import {setupListeners} from '@reduxjs/toolkit/query'
// import {createLogger} from 'redux-logger'
import baseApi from './slices/api/baseApi'
import app from './slices/app'
import rtkQueryToasterHandler from './middleware/rtkQueryToasterHandler'

// const logger = createLogger({
//     predicate: (getState, action) => action.type !== 'SET_PROCESSING',
// })

const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
        app,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            // .concat(logger)
            .concat(baseApi.middleware)
            .concat(rtkQueryToasterHandler),
})

setupListeners(store.dispatch)

export * from './slices/api/authApi'
export * from './slices/api/accountsApi'
export * from './slices/api/usersApi'
export * from './slices/api/danceApi'
export * from './slices/api/mediaApi.js'
export * from './slices/api/uploadApi.js'
export * from './slices/api/choreographersApi.js'
export * from './slices/api/artistsApi.js'
export * from './slices/app'

export default store
